import { SoundTrack } from '../types';

export const sounds: SoundTrack[] = [
  {
    id: 'sound-1',
    title: 'Project 4 — Trans1',
    category: 'sound-design',
    fileUrl: '/sounds/Project 4 - Trans1.mp3',
    date: '2021',
    description: 'sounds.song-1.description',
  }, 
  {
    id: 'sound-2',
    title: 'Otter village',
    category: 'music',
    fileUrl: '/sounds/Real 3 - Tof9.mp3',
    date: '2021',
    description: 'sounds.trans2.description',
  },
  {
    id: 'sound-3',
    title: 'Real 1 - Pos4',
    category: 'music',
    fileUrl: '/sounds/Real 1 - Pos4.mp3',
    date: '2020',
    description: 'sounds.trans2.description',
  },
];

export const getSoundsByCategory = (category: SoundTrack['category']) =>
  sounds.filter((s) => s.category === category);
